import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './AssignSuccess.module.css';

const AssignSuccess = ({
  entry,
  slotLabel,
  successfulCount,
  attemptedCount,
  errors,
  onAssignAnother,
}) => {
  const entryName = entry ? entry.displayName || entry.sleepScreenId : '';
  const failedCount = errors.length;
  const partial = failedCount > 0 && successfulCount > 0;
  const allFailed = failedCount > 0 && successfulCount === 0;

  let titleText = 'Assignment complete';
  if (partial) titleText = 'Assignment partially complete';
  if (allFailed) titleText = 'Assignment failed';

  return (
    <section className={styles.card}>
      <div className={styles.checkRow}>
        <span
          className={allFailed ? styles.checkFail : styles.check}
          aria-hidden="true"
        >
          {allFailed ? '!' : '✓'}
        </span>
        <h2 className={styles.title}>{titleText}</h2>
      </div>
      <p className={styles.sentence}>
        <strong>{successfulCount.toLocaleString()}</strong>{' '}
        {successfulCount === 1 ? 'fridge is' : 'fridges are'} now playing{' '}
        <strong>{entryName}</strong> in the <strong>{slotLabel}</strong> slot.
      </p>

      <dl className={styles.detailsGrid}>
        <dt>Entry</dt>
        <dd>{entryName}</dd>
        <dt>Slot</dt>
        <dd>{slotLabel}</dd>
        <dt>Attempted</dt>
        <dd>{attemptedCount.toLocaleString()}</dd>
        <dt>Successful</dt>
        <dd>{successfulCount.toLocaleString()}</dd>
        <dt>Failed</dt>
        <dd>{failedCount.toLocaleString()}</dd>
      </dl>

      {failedCount > 0 && (
        <div className={styles.errorBlock}>
          <div className={styles.errorBlockTitle}>
            {failedCount} {failedCount === 1 ? 'fridge' : 'fridges'} could not
            be assigned
          </div>
          <ul className={styles.errorList}>
            {errors.map((e) => (
              <li key={`${e.schemaId}-${e.reason}`} className={styles.errorRow}>
                <span className={styles.mono}>{e.schemaId}</span>
                <span className={styles.errorReason}>{e.reason}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className={styles.actionRow}>
        {entry && (
          <Link
            to={{
              pathname: `/sleep-screens/${encodeURIComponent(
                entry.sleepScreenId,
              )}`,
              state: { justAssigned: true },
            }}
            className={styles.primaryLink}
          >
            View entry
          </Link>
        )}
        <button
          type="button"
          className={styles.secondaryButton}
          onClick={onAssignAnother}
        >
          Assign another
        </button>
      </div>
    </section>
  );
};

AssignSuccess.propTypes = {
  entry: PropTypes.shape({
    sleepScreenId: PropTypes.string,
    displayName: PropTypes.string,
  }),
  slotLabel: PropTypes.string.isRequired,
  successfulCount: PropTypes.number.isRequired,
  attemptedCount: PropTypes.number.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      schemaId: PropTypes.string.isRequired,
      reason: PropTypes.string.isRequired,
    }),
  ),
  onAssignAnother: PropTypes.func.isRequired,
};

AssignSuccess.defaultProps = {
  entry: null,
  errors: [],
};

export default AssignSuccess;
